import * as type from "../../types";

export function setLeadMode(mode) {
    return {
        type: type.SET_LEAD_MODE,
        payload: mode, // "subscription" | "retail"
    };
}

export function resetLeadMode() {
    return {
        type: type.RESET_LEAD_MODE,
    };
}
